import { render, staticRenderFns } from "./TheTableRestaurants.vue?vue&type=template&id=7a792b1a&scoped=true&"
import script from "./TheTableRestaurants.vue?vue&type=script&lang=ts&"
export * from "./TheTableRestaurants.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a792b1a",
  null
  
)

export default component.exports